import { z } from 'zod/v4';

import { videoResourceSchema } from '~teacher/models/quizzes';

export type Image = z.infer<typeof imageSchema>;
export const imageSchema = z.object({
  id: z.number(),
  url: z.string(),
  type: z.string(),
  data: z.any().optional(),
  urlXS: z.string().optional(),
  urlS: z.string().optional(),
  urlM: z.string().optional(),
  urlL: z.string().optional(),
  urlXL: z.string().optional(),
});

export const answerSchema = z.object({
  id: z.number(),
  created_by_id: z.number(),
  text: z.string(),
  isCorrect: z.boolean(),
  order: z.number(),
  questionId: z.number(),
  legacyId: z.any().optional(),
  image: imageSchema.optional(),
});

export type Answer = z.infer<typeof answerSchema>;

export const questionImageSchema = z.object({
  id: z.number(),
  url: z.string(),
  type: z.string(),
  data: z.any().optional(),
  urlXS: z.string().optional(),
  urlS: z.string().optional(),
  urlM: z.string().optional(),
  urlL: z.string().optional(),
  urlXL: z.string().optional(),
});
export type QuestionImage = z.infer<typeof questionImageSchema>;

export const explanationImageSchema = z.object({
  id: z.number(),
  url: z.string(),
  type: z.string(),
  data: z.any().optional(),
  urlXS: z.string().optional(),
  urlS: z.string().optional(),
  urlM: z.string().optional(),
  urlL: z.string().optional(),
  urlXL: z.string().optional(),
});
export type ExplanationImage = z.infer<typeof explanationImageSchema>;

export const questionSchema = z.object({
  questionId: z.number(),
  type: z.string(),
  createdById: z.number(),
  order: z.number(),
  questionText: z.string(),
  explanation: z.string(),
  createdDate: z.date(),
  gradingWeight: z.number(),
  quizId: z.number(),
  legacyId: z.any().optional(),
  answers: z.array(answerSchema),
  questionImage: questionImageSchema,
  explanationImage: explanationImageSchema,
  questionVideo: videoResourceSchema,
});

export type Question = z.infer<typeof questionSchema>;

export interface CreateQuizResponse {
  createdById: number;
  id: number;
  sharable: boolean;
  isHidden: boolean;
  createdDate: Date;
  name: string;
  lastUpdated: Date;
  socNumber: string;
  questions: Question[];
  standard?: unknown;
  version: number;
}

export const orderSchema = z.object({
  questionId: z.number(),
  order: z.number(),
});
export type Order = z.infer<typeof orderSchema>;

export interface CreateQuestionResponse {
  questions: Question[];
  orders: Order[];
}

export interface QuestionResponse {
  question: Question;
  orders: Order[];
}
